// extracted by mini-css-extract-plugin
module.exports = {"variantNameContainer":"InventoryList_variantNameContainer__3n-hO","variantKey":"InventoryList_variantKey__3ZfEb","actionsContainer":"InventoryList_actionsContainer__1I8l6"};